<cs-widget-composition *ngIf="isLobbyLoaded"></cs-widget-composition>
